<template>
  <div class="grid pb-0">
    <div class="p-3 bg-white">
      <!-- thay doi giong cai nay -->
      <v-btn-toggle v-model="toggle_exclusive" class="d-gr-btn-update">
        <v-btn v-for="(item, index) in tabItems" :key="item.key"
          @click="loadRoute(item.routeName); tab = index" :class="index === tab ? 'd-btn-active' : ''">
          {{ item.title }}
        </v-btn>
      </v-btn-toggle>
    </div>
    <v-progress-linear color="warning" indeterminate rounded height="3" v-if="isLoading"></v-progress-linear>
    <div class="grid-body border-top-unset">
      <div>
        <router-view></router-view>
      </div>
    </div>
  </div>
</template>

<script>
import { _formatCurrency, _formatDate, _alert } from "@/_helpers/function.js";
export default {
	components: {},
	data() {
		return {
			syncPMS: JSON.parse(localStorage.getItem("currentUser")).hotel.syncPMS,
			isLoading: false,
			systemLang: this.$i18n.locale,
			tab: 0,
			syncInventory: JSON.parse(localStorage.getItem("currentUser")).hotel.syncInventory,
			toggle_exclusive: 0
		};
	},
	computed: {
		tabItems() {
			return [
				{
					title: this.$t('STOP_SELL_LIMIT'),
					key: 'stopUnderSell',
					disabled: false,
					routeName: "stopUnderSellLimit",
				},
				{
					title: this.$t('SELL_LIMIT'),
					key: 'stopSell',
					disabled: false,
					routeName: "stopSellLimit",
				}
			]
		}
	},
	created() {
		switch (this.$route.name) {
			case 'stopUnderSellLimit':
				this.tab = 0;
				break;
			case 'stopSellLimit':
				this.tab = 1;
				break;
			default:
				break;
		}
	},
	watch: {
		'$route.query': 'fetchData',
	},
	methods: {
		loadRoute(routeName) {
			this.$router.push({ name: routeName });
		},
		_formatCurrency: _formatCurrency,
		formatDate: _formatDate,
	}
};
</script>